<template>
  <vs-sidebar
    click-not-close
    position-right
    parent="body"
    default-index="1"
    color="primary"
    class="sidebarx"
    spacer
    v-model="updateClientConfig.isOpen"
    id="update-new-client"
  >
    <div class="flex items-center justify-between px-6">
      <h4 class="text-2xl font-bold">Edit New Client Campaign Info</h4>
      <feather-icon icon="XIcon" @click.stop="closeUpdateClient" class="cursor-pointer"></feather-icon>
    </div>
    <vs-divider class="mb-0"></vs-divider>
    <VuePerfectScrollbar class="scroll-area--data-list-add-new" :settings="settings">
      <div class="sidebar-content p-6 scroll">
        <div class="info-form"
        data-aos="fade-up"
        data-aos-offset="200"
        data-aos-delay="10"
        data-aos-duration="1000"
        data-aos-easing="ease-in-out"
        data-aos-once="false"
        data-aos-anchor-placement="top-center"
        >
            <h4 class="text-lg font-bold">What is your new client offer name?</h4>
            <div class="centerx labelx">
              <vs-input disabled v-model="client_name" class="w-full new-client-name" :maxlength="50" v-validate="'required'" name="client_name" :danger="errors.has('client_name')"
              danger-text="The client name field is required"/>
            </div>
            <div class="centerx labelx">
              <vs-input disabled="true" v-model="text" class="w-full"/>
            </div>
            <h4 class="text-lg font-bold mt-6">What is the value of promotion?</h4>
            <div class="w-row">
              <ul class="centerx flex align-center justify-between">
                <vs-input-number min="0" :max="max" :key="abc" v-model="client_logic_value" class="w-7/12"/>
                <li @click="max=100,abc++">
                  <vs-radio v-model="client_logic_type" vs-value="percent" class="flex align-center m-0">%</vs-radio>
                </li>
                <li @click="max=999,abc++" class="mr-base">
                  <vs-radio v-model="client_logic_type" vs-value="usd" class="flex align-center m-0">$</vs-radio>
                </li>
              </ul>
            </div>
            <h4 class="text-lg font-bold mt-4">Change Status</h4>
            <ul class="switch-container">
               <li>
                <vs-switch v-model="client_is_active" @click.stop="switchActive"/>
              </li>
            </ul>
          </div>
        </div>
      </VuePerfectScrollbar>
    <div class="flex justify-center flex-wrap items-center p-6" slot="footer">
      <vs-button class="mr-6" @click="updateClient" style="min-width: 140px">Submit</vs-button>
      <vs-button type="border" color="danger" @click.stop="closeUpdateClient" style="min-width: 140px">Cancel</vs-button>
    </div>
  </vs-sidebar>
</template>

<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar';
import flatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';

export default {
  name: "vs-update-client",
  components: {
    SideBarItem: () => import("../../components/SideBarItem.vue"),
    flatPickr,
    VuePerfectScrollbar,
  },
  props: {
    updateClientConfig: {
      type: Object,
      required: true
    },
    sidebarData: {
      type: Object,
      required: true
    }
  },
  data() {
      return {
          text:"After first sign up! New client will receive promotion..",
          name: this.sidebarData.campaign.name,
          logic_value: this.sidebarData.campaign.logic_value,
          logic_type: this.sidebarData.campaign.logic_type,
          is_active: this.sidebarData.campaign.is_active,

          settings: { // perfectscrollbar settings
            maxScrollbarLength: 60,
            wheelSpeed: .60,
          },
          max: 100,
          abc: 0,
      }
  },
  computed: {
      id:{
        get(){return this.sidebarData.campaign.id},
        set(){}
      },
      client_name: {
          get() { return  this.name; },
          set(value) {
              this.name = value;
           }
      },
      client_logic_value:{
        get() {return this.logic_value},
        set(value) {
          this.logic_value = value;
        }
      },
      client_logic_type:{
        get() {return this.logic_type},
        set(value) {
          this.logic_type = value;
        }
      },
      client_is_active:{
        get(){return this.is_active;},
        set(value){
          this.is_active = value
        }
      }
  },
  watch: {
    updateClientConfig: {
      immediate: true,
      deep: true,
      handler() {
        this.name = this.sidebarData.campaign.name
        this.logic_value = this.sidebarData.campaign.logic_value;
        this.is_active = this.sidebarData.campaign.is_active;
        this.errors.clear();
        if(this.updateClientConfig.isOpen) {
          this.logic_type = this.sidebarData.campaign.logic_type;
          if(this.logic_type == 'usd'){
            this.max = 999;
          }else {
            this.max = 100;
          }
          document.body.classList.add('overflow-hidden');
        } else {
          document.body.classList.remove('overflow-hidden');
        }
      }
    },
    max: {
      immediate: true,
      deep: true,
      handler(val) {
        if(this.client_logic_value > val) {
          this.client_logic_value = val;
        }
      }
    }
  },
  methods: {
    updateClient(){
      if(this.client_name != "") {
        const obj = {
          id: this.id,
          name: this.name,
          is_active: this.is_active ? 1 : 0,
          logic_value: this.logic_value,
          logic_type: this.logic_type,
        };
        // console.log(obj)
        this.$emit("UpdateClient" ,obj);
        this.closeUpdateClient();
      }
      this.$validator.validateAll();
    },
    switchActive(){
      this.is_active = this.is_active;
    },
    closeUpdateClient() {
      this.$emit("CloseUpdateClient");
    },
  }
};
</script>
